import { Box, styled } from "@mui/material";

export const ExpandIcon = styled(Box)`
  display: inline-block;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 8px solid ${(props) => props.theme.palette.primary.contrastText};

  &[aria-expanded="true"] {
    transform: rotate(90deg);
  }
`;
